import { keysToCamel } from "@lib/snakeTocamel"

export const parseSlotSelectionData = (widgets) => {
    const parsedData = {}

    const slotSelector = widgets?.slot_selector
    parsedData.slotSelector = {
        header: slotSelector?.data?.header,
        cta: keysToCamel(slotSelector?.data?.cta),
        gaDetails: slotSelector?.data?.ga_details || {},
        onChangeGaDetails: slotSelector?.data?.on_change_ga_details || {},
        slots: {},
    }

    let slot
    slotSelector?.data?.days_array?.forEach((day) => {
        slot = {
            title: day?.title,
            available: day?.available,
            epochSlot: day?.epoch_slot,
            isSelected: day?.is_selected,
            dayIndex: day?.day_index,
            date: day?.date,
        }
        slot.timeSlotData = {}
        const timeSlotData = slotSelector?.data?.time_slot_data[slot.epochSlot]
        if (timeSlotData) {
            if (!timeSlotData?.slot_data?.length) {
                slot.timeSlotData.emptySlot = {
                    image: {
                        url: timeSlotData?.empty_slot_data?.image?.url,
                        alt: timeSlotData?.empty_slot_data?.image?.alt || "No Slot",
                        height: timeSlotData?.empty_slot_data?.image?.height,
                        width: timeSlotData?.empty_slot_data?.image?.width,
                    },
                    header: timeSlotData?.empty_slot_data?.heading,
                    description: timeSlotData?.empty_slot_data?.description,
                }
            } else {
                slot.timeSlotData.timeSlots = timeSlotData?.slot_data?.map((item) => ({
                    slotId: item?.slot_id,
                    epochSlot: item?.epoch_slot,
                    label: item?.label,
                    subText: item?.sub_text,
                    available: true,
                    isSelected: item?.is_selected,
                    slotIndex: item?.slot_index,
                }))
            }
        }
        if (slot.isSelected) {
            parsedData.slotSelector.selectedSlotId = slot.epochSlot
        }

        parsedData.slotSelector.slots[slot.epochSlot] = slot
    })
    parsedData.noSlots = keysToCamel(widgets?.no_slot_widget?.data)
    parsedData.labsPreparation = keysToCamel(widgets?.labs_preparation?.data)
    return parsedData
}
